import { render, staticRenderFns } from "./changeMobile.vue?vue&type=template&id=08922bd0&scoped=true&"
import script from "./changeMobile.vue?vue&type=script&lang=js&"
export * from "./changeMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08922bd0",
  null
  
)

export default component.exports